import * as React from "react";
export var ProfilePicture = function (_a) {
    var onClick = _a.onClick, profilePictureName = _a.profilePictureName, profilePictureClassName = _a.profilePictureClassName, profilePictureSize = _a.profilePictureSize, children = _a.children;
    var isButton = onClick === undefined ? "" : "with-button-cursor-hover";
    return (React.createElement("div", { className: profilePictureClassName + " " + profilePictureSize + "-" + profilePictureName + " " + isButton, onClick: onClick },
        React.createElement("div", { className: profilePictureClassName + "__frame w100 h100" }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/ProfilePicture.tsx
// module id = 138
// module chunks = 3